export const PLATFORM_ROLES = ["platform_owner", "platform_operator"] as const;

export type PlatformRole = (typeof PLATFORM_ROLES)[number];

export const PLATFORM_ROLE_LABELS: Record<PlatformRole, string> = {
  platform_owner: "運営統括管理者",
  platform_operator: "運営担当者",
};

export const isPlatformRole = (role: unknown): role is PlatformRole =>
  typeof role === "string" &&
  PLATFORM_ROLES.some((candidate) => candidate === role);

export const isPlatformOwner = (role: unknown): role is "platform_owner" =>
  role === "platform_owner";
